import twitter from './../assets/projet.png';
import mycine from './../assets/mycine.png';
import snap from './../assets/snap.jpg';
import france from './../assets/france.png';
import us from './../assets/us.png';
import meetic from './../assets/meetic.jpg';
import irc from './../assets/irc.jpg';

const fr = {
    navbar: {
      home: "Accueil",
      experience: "Expérience",
      projects: "Projets",
      contact: "Contacter",
      changeLanguage: "Changer de langue"
    },
    hero: {
      hello: "Bonjour, je m'appelle",
      name: "Tony Brechard.",
      description: "Je suis un jeune développeur full stack passionné par la création de solutions web complètes. Avec des compétences en développement front-end et back-end.",
      seeProjects: "Voir mes projets"
    },
    education: {
      title: "Expérience",
      date: "2024-2026",
      school: "Web@cadémie by Epitech",
      description: "La Web@cadémie by Epitech est une formation intensive de 24 mois qui prépare des jeunes, avec ou sans diplôme, aux métiers de développeur web. La formation combine une pédagogie par projets, une immersion intensive en code, et une alternance, permettant ainsi aux étudiants de valider un titre reconnu tout en acquérant une expérience professionnelle solide.",
      tags: ["JavaScript", "PHP", "HTML/CSS", "MySQL", "React", "Express", "Symfony", "SocketIo", "Laravel"]
    },
    projects: {
        title: "Projets",
        webButton: "Web",
        mobileButton: "Mobile",
        web: [
          {
            title: "Mon IRC",
            description: "Un projet web simulant un site de cinéma, avec des fonctionnalités telles que l'affichage des films, la réservation de billets, et l'authentification des utilisateurs.",
            tags: ["Node.Js", "Express.js", "CSS", "Socket.io", "React.js"],
            image: irc,
            link: 'https://github.com/onlyguts/my_irc'
          },
          {
            title: "Mon Meetic",
            description: "Un projet web simulant un site de rencontres, avec des fonctionnalités telles que l'inscription des utilisateurs, la recherche de profils et l'envoi de messages.",
            tags: ["PHP", "HTML/CSS", "MySQL"],
            image: meetic,
            link: 'https://github.com/onlyguts/my_meetic'
          },
          {
            title: "Mon Cinéma",
            description: "Un projet web simulant un site de cinéma, avec des fonctionnalités telles que l'affichage des films, la réservation de billets, et l'authentification des utilisateurs.",
            tags: ["PHP", "HTML/CSS", "MySQL"],
            image: mycine,
            link: 'https://github.com/onlyguts/my_cinema'
          },
          {
            title: "Mon Twitter",
            description: "Un clone web de Twitter qui permet aux utilisateurs de publier des tweets, de suivre d'autres utilisateurs, et d'interagir via des likes et des commentaires.",
            tags: ["PHP", "JavaScript", "HTML/CSS", "MySQL", 'Ajax'],
            image: twitter,
            link: 'https://github.com/onlyguts/my_twitter'
          }
        ],
        mobile: [
          {
            title: "Mon Snapchat",
            description: "Une application mobile qui reproduit les fonctionnalités de base de Snapchat, y compris l'envoi de snaps, la visualisation des stories, et la messagerie.",
            tags: ["TypeScript", "React Native", "Expo", 'CSS'],
            image: snap,
            link: 'https://github.com/onlyguts/my_snapchat'
          }
        ]
      },
    contact: {
      title: "Contacter",
      form: {
        name: "Nom",
        email: "Email",
        subject: "Sujet",
        message: "Message",
        send: "Envoyer"
      }
    },
    footer: "© Tony BRECHARD 2024. - Tous droits réservés."
  };
  
  export default fr;
  